// extracted by mini-css-extract-plugin
export default {"loading":"LoadingCircle_loading__ympdw","loader-spin":"LoadingCircle_loader-spin__uqTbE"};